export default "__VITE_ASSET__DOnaXw4D__"